import React from 'react';
import { Shield, Globe, Users, Zap, Award, HeartHandshake } from 'lucide-react';
const features = [{
  icon: Globe,
  title: 'Global Platform, Local Focus',
  description: 'Locanto operates in over 60 countries worldwide, connecting millions of users. In Singapore, we focus on bringing your neighbourhood together — from Orchard to Tampines, Jurong to Woodlands.'
}, {
  icon: Zap,
  title: '100% Free to Post',
  description: "Unlike other platforms, Locanto never charges you to post a classified ad. Whether you're selling a phone, renting a room, or advertising your services — it's completely free."
}, {
  icon: Shield,
  title: 'Safe & Trusted',
  description: 'Your safety is our priority. We provide safety tips for every transaction, verified seller badges, and a dedicated support team to keep the community trustworthy.'
}, {
  icon: Users,
  title: 'Vibrant Community',
  description: 'Join over 500,000 active users in Singapore who use Locanto every month to buy, sell, find jobs, discover events, and connect with like-minded people.'
}, {
  icon: Award,
  title: 'Diverse Categories',
  description: 'From Jobs and Real Estate to Vehicles, Services, Community events, and Personal ads — Locanto covers every aspect of local life in Singapore.'
}, {
  icon: HeartHandshake,
  title: 'People-First Approach',
  description: 'We believe in direct, person-to-person connections. No middlemen, no hidden fees. Just real people helping each other in their local community.'
}];
export function AboutLocanto() {
  return <section className="py-16 bg-white" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        {/* Main Intro */}
        <div className="max-w-3xl mx-auto text-center mb-14" data-id="element-3">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-4">
            About Locanto Singapore
          </h2>
          <p className="text-gray-600 leading-relaxed text-lg mb-4" data-id="element-5">
            Welcome to <strong className="text-[#00897B]" data-id="element-6">Locanto</strong> —
            Singapore's trusted free classifieds platform. Since our founding,
            we've been on a mission to make local buying, selling, and
            connecting as simple and accessible as possible.
          </p>
          <p className="text-gray-500 leading-relaxed" data-id="element-7">
            Whether you're a first-time seller looking to declutter, a job
            seeker exploring opportunities, a landlord listing a property, or
            someone searching for local services and events — Locanto is your
            go-to destination. Our platform is designed to be fast, intuitive,
            and completely free for everyone.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-14" data-id="element-8">
          {features.map((feature, index) => <div key={index} className="flex gap-4" data-id="element-9">
              <div className="flex-shrink-0 h-12 w-12 bg-[#E0F2F1] rounded-lg flex items-center justify-center text-[#00897B]" data-id="element-10">
                <feature.icon className="h-6 w-6" data-id="element-11" />
              </div>
              <div data-id="element-12">
                <h3 className="font-semibold text-gray-900 mb-2" data-id="element-13">
                  {feature.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed" data-id="element-14">
                  {feature.description}
                </p>
              </div>
            </div>)}
        </div>

        {/* Stats Bar */}
        <div className="bg-[#F5F5F5] rounded-xl p-8" data-id="element-15">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-16">
            <div data-id="element-17">
              <p className="text-3xl font-bold text-[#00897B]" data-id="element-18">60+</p>
              <p className="text-sm text-gray-500 mt-1" data-id="element-19">Countries Worldwide</p>
            </div>
            <div data-id="element-20">
              <p className="text-3xl font-bold text-[#00897B]" data-id="element-21">500K+</p>
              <p className="text-sm text-gray-500 mt-1" data-id="element-22">Monthly Users in SG</p>
            </div>
            <div data-id="element-23">
              <p className="text-3xl font-bold text-[#00897B]" data-id="element-24">14K+</p>
              <p className="text-sm text-gray-500 mt-1" data-id="element-25">Active Listings</p>
            </div>
            <div data-id="element-26">
              <p className="text-3xl font-bold text-[#00897B]" data-id="element-27">100%</p>
              <p className="text-sm text-gray-500 mt-1" data-id="element-28">Free to Use</p>
            </div>
          </div>
        </div>

        {/* Bottom Text */}
        <div className="max-w-3xl mx-auto text-center mt-14" data-id="element-29">
          <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-30">
            Why Singaporeans Choose Locanto
          </h3>
          <p className="text-gray-500 leading-relaxed mb-4" data-id="element-31">
            In a city as dynamic as Singapore, Locanto bridges the gap between
            neighbours, businesses, and communities. Our platform is built for
            speed — post an ad in under 2 minutes and start receiving responses
            right away. No sign-up fees, no listing charges, no commissions.
          </p>
          <p className="text-gray-500 leading-relaxed" data-id="element-32">
            From the bustling markets of Chinatown to the residential heartlands
            of Ang Mo Kio, Locanto helps Singaporeans find exactly what they
            need, right in their neighbourhood. Join our growing community today
            and experience the easiest way to buy, sell, and connect locally.
          </p>
        </div>
      </div>
    </section>;
}